$('.image-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    prevArrow: '<div class="-right-0 z-10 top-auto fas fa-chevron-left absolute text-2xl pb-6 px-5 bottom-0 text-white mr-11 cursor-pointer arrow-shadow"></div>',
    nextArrow: '<div class="-right-0 z-10 top-auto fas fa-chevron-right absolute text-2xl pb-6 px-5 bottom-0 text-white cursor-pointer arrow-shadow"></div>'
});

jQuery('.slick-carousel.footer-certificate-logo-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 768,
            settings: 'unslick'
        }
    ]
});